import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

const CleanLink: React.FC<LinkProps> = ({ style, ...linkProps }) => (
	<Link
		style={{
			textDecoration: 'none',
			color: 'inherit',
			...style
		}}
		{...linkProps}
	/>
);

export default CleanLink;
